import React, { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment-timezone';
import CommonHeader from '../../../util_components/common_header';
import { post_api } from '../../../../redux/api_funcs';
import { check_null_text } from '../../../../util_functions';
import { day_format, time_format } from '../../../../constants';
import * as actions from '../../../../redux/action_creators';
import { get_api_url } from '../../../../utils/urls';

// Reports > Extra Participant Charges: students opted-in to invite-a-friend charging (flag = 1).
// Read-only; charging is toggled from the student profile edit page.
const ExtraParticipantCharges = () => {
  const iana_timezone = useSelector((state) => state.home.iana_timezone);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [students, setStudents] = useState([]);
  const [search_text, setSearchText] = useState('');

  const load_data = useCallback(() => {
    setLoading(true);
    const url = get_api_url('get_extra_participant_charge_students');
    post_api(url, null, true)
      .then((res) => {
        setStudents(res.data.students || []);
        setLoading(false);
      })
      .catch((e) => {
        let err_message;
        try {
          err_message = e.response.data.message;
        } catch (err) {
          err_message = 'Some error occured. Please contact dev team.';
        }
        dispatch(actions.set_notification_variable(true, 'error', err_message));
        setLoading(false);
      });
  }, [dispatch]);

  useEffect(() => {
    load_data();
  }, [load_data]);

  const format_date = (value) => {
    if (!value) return '--';
    const m = moment(value).tz(iana_timezone);
    return (
      <>
        <div>{m.format(day_format)}</div>
        <div>{m.format(time_format)}</div>
      </>
    );
  };

  const q = search_text.trim().toLowerCase();
  const filtered = !q
    ? students
    : students.filter(
        (s) =>
          (s.name && s.name.toLowerCase().indexOf(q) !== -1) ||
          (s.email && s.email.toLowerCase().indexOf(q) !== -1)
      );

  const render_single = (student) => {
    const student_url = `/studentprofile?id=${student.uuid}`;
    return (
      <div className="ct-row" key={student.uuid}>
        <div className="ct-col ct-la">
          <a className="link-no-dec" href={student_url}>
            <div>{check_null_text(student.name)}</div>
            <div className="ct-sm-font">{check_null_text(student.email)}</div>
          </a>
        </div>
        <div className="ct-col ct-sm-font">{check_null_text(student.country)}</div>
        <div className="ct-col ct-sm-font">{check_null_text(student.timezone)}</div>
        <div className="ct-col ct-sm-font">{format_date(student.created_date)}</div>
        <div className="ct-col ct-sm-font">{check_null_text(student.enabled_by)}</div>
        <div className="ct-col ct-sm-font">{format_date(student.enabled_at)}</div>
      </div>
    );
  };

  return (
    <CommonHeader
      loading={loading}
      title="Extra Participant Charges"
      subtitle="Students set up to be charged for extra participants they invite to their 1-on-1 sessions. Toggle from the student profile. (Yoga With Friends group-session charges are separate.)"
    >
      <div style={{ margin: '10px 0', display: 'flex', alignItems: 'center', gap: '10px' }}>
        <input
          type="text"
          placeholder="Search by name or email"
          value={search_text}
          onChange={(e) => setSearchText(e.target.value)}
          style={{
            padding: '8px',
            width: '280px',
            borderRadius: '4px',
            background: 'var(--input-bg)',
            border: '1px solid var(--input-border)',
            color: 'var(--input-text)'
          }}
        />
        <span className="ct-sm-font">{filtered.length} student(s)</span>
      </div>
      <div className="cus-table" style={{ marginBottom: '20px' }}>
        <div className="ct-row ct-h">
          <div className="ct-col ct-la">Student</div>
          <div className="ct-col">Country</div>
          <div className="ct-col">Timezone</div>
          <div className="ct-col">Signup Date</div>
          <div className="ct-col">Enabled By</div>
          <div className="ct-col">Enabled On</div>
        </div>
        {filtered.length > 0 ? (
          filtered.map(render_single)
        ) : (
          <div className="ct-row">
            <div className="ct-col">
              {loading ? 'Loading...' : 'No students are set up for charging.'}
            </div>
          </div>
        )}
      </div>
    </CommonHeader>
  );
};

export default ExtraParticipantCharges;
